import { PolicyView } from './types/policyTypes';

export function createDefaultPolicy(): PolicyView {
  return {
    id: '',
    policyNumber: '',
    policyName: '',
    company: '',
    effectiveDate: null,
    reviewDate: null,
    category: '',
    effectiveProcedureCodes: [],
    effectiveInsurances: [],
    policySummary: '',
  };
}
